var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M15.5 3.0199V3.0199C15.5 3.81028 15.186 4.56828 14.6271 5.12717C14.0683 5.68605 13.3102 6.00003 12.5199 6.00003H11.4801C10.6898 6.00003 9.93174 5.68605 9.37286 5.12717C8.81398 4.56828 8.5 3.81028 8.5 3.0199V3.0199",
    stroke: "#21242B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M17.9874 13.996L21.2288 13.2325C21.4892 13.1711 21.7142 13.0079 21.8535 12.7794C21.9927 12.5509 22.0346 12.2762 21.9697 12.0166L20.6739 6.83366C20.3837 5.67276 19.589 4.70277 18.5079 4.18987L16.8135 3.38606C16.2777 3.13187 15.6921 3 15.0991 3H8.90047C8.30742 3 7.72179 3.13187 7.18598 3.38606L5.49167 4.18987C4.41053 4.70277 3.61581 5.67276 3.32558 6.83366L2.02986 12.0165C1.96496 12.2761 2.00681 12.5509 2.14604 12.7794C2.28527 13.0079 2.51028 13.1711 2.77073 13.2324L5.98723 13.9901",
    stroke: "#21242B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M4.16406 5.19813L5.63207 8.80702C5.87546 9.40532 6.00061 10.0451 6.0006 10.691L6.00048 19.5433C5.99058 20.4414 6.58807 21.233 7.45448 21.4697C10.444 22.1769 13.5573 22.1768 16.5467 21.4695C17.413 21.2327 18.0104 20.4411 18.0005 19.5431L18.0004 10.6908C18.0004 10.0449 18.1255 9.40509 18.3689 8.80678L19.8369 5.19794",
    stroke: "#21242B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloth);
export default __webpack_public_path__ + "static/media/cloth.2db494d29849c03b09cdaa5e273ed91a.svg";
export { ForwardRef as ReactComponent };